export enum VacancyStatus {
  OPEN = 1,
  CLOSED = 2,
}
